import { useState } from "react";
import { API_URL } from "src/util/config";
import { checkResponse } from "src/util/helpers";
import { useAuth } from "src/contexts/AuthContext";

interface CreationResult {
  requestId: string;
  creditMemoTranId: string;
  status: "SUCCESS" | "FAIL";
  message?: string;
}

export const useCreateCreditMemoSendRequests = () => {
  const [creationResults, setCreationResults] = useState<CreationResult[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { fetchWithReauth } = useAuth();

  const createCreditMemoSendRequests = async (
    creditMemoTranIds: string[],
    jiraTicketId?: string
  ) => {
    setLoading(true);
    try {
      const body: { creditMemoTranIds: string[]; jiraTicketId?: string } = {
        creditMemoTranIds,
      };
      const ticket = String(jiraTicketId || "").trim();
      if (ticket) body.jiraTicketId = ticket;
      const response = await fetchWithReauth(`${API_URL}/credit-memos`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      });
      const data = await checkResponse(response);
      setCreationResults(data.results);
    } catch (error) {
      console.error("Error creating credit memo send requests:", error);
    } finally {
      setLoading(false);
    }
  };

  return {
    creationResults,
    loading,
    createCreditMemoSendRequests,
  };
};
